import { Link } from 'react-router'
import { Fragment } from 'react/jsx-runtime'

import SlashIcon from 'assets/icons/slash.svg'

import styles from './Breadcrumb.module.scss'

interface BreadcrumbProps {
  paths: {
    name: string
    path?: string
  }[]
}

const Breadcrumb = ({ paths }: BreadcrumbProps) => (
  <div className={styles.breadcrumb} data-testid="breadcrumb">
    {paths.map((path, index) => (
      <Fragment key={path.name}>
        {index > 0 && <SlashIcon />}

        {path.path ? <Link to={path.path}>{path.name}</Link> : <span>{path.name}</span>}
      </Fragment>
    ))}
  </div>
)

export default Breadcrumb
